import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './apply-policy.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';
import { ScheduleSelector } from '../../dataprotection-common/schedule-selector/schedule-selector.component';

@Component({
  selector: 'apply-policy',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./apply-policy.scss')],
  template: require('./apply-policy.html')
})

export class ApplyPolicy {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedEntity') selectedEntity: any;
  @Input('policyData') policyData: any;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private subscribeHandler;
  private isRequestPending: boolean = false;
  private active: boolean = true;
  private _policyData;
  private isFormValueChanged: boolean = false;

  private emitData = {
    'status': '',
  };


  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    if(f.valid) {
      this.isRequestPending = true;
      this.emitData.status = 'pending';
      this.emitter.emit(this.emitData);
      let obj = this.formatPolicyObject(f.value);
      switch(this.mode){
        case DataProtectionVariables.POLICY_POPUP_MODES['ADD_RESOURCE_POOL_POLICY']:
          this.addResourcePoolPolicy(obj);
          break;
        case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_RESOURCE_POOL_POLICY']:
          this.updateResourcePoolPolicy(obj);
          break;
        case DataProtectionVariables.POLICY_POPUP_MODES['ADD_VM_POLICY']:
          this.addVmPolicy(obj);
          break;
        case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VM_POLICY']:
          this.updateVmPolicy(obj);
          break;
        default :
          this.addResourcePoolPolicy(obj);
      }
    }
  }

  onCancelButtonClicked() {
    this.emitter.emit();
  }

  //Workaround until form has a reset method
  reset() {
    this.active = false;
    this.resetSelection();
    setTimeout(() => this.active = true, 0);
  }


  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(this.isVisible && this.policyData && this.policyData.schedule) {
      this.isFormValueChanged = false;
      this._policyData = JSON.parse(JSON.stringify(this.policyData));
      if(this._policyData.hasOwnProperty('retention') && this._policyData['retention'].hasOwnProperty('days')) {
        setTimeout((rtn) => this._policyData['retention']['days'] = rtn, 100, this._policyData['retention']['days']);
      }
    } else {
      this.reset();
    }
  }

  onFormValueChange() {
    this.isFormValueChanged = true;
  }

  resetSelection() {
    this._policyData =
      {
        "schedule": {
          "startTime" : "00:00:00",
          "timeZone" : "America/Los_Angeles",
          "scheduleType" : "Daily"
        },
        "retention" : {
            "days" : 0
        }
      }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  formatPolicyObject(formValue) {
    let obj = JSON.parse(JSON.stringify(formValue));
    if( formValue.hasOwnProperty('retention') ) {
      let numOfDays = formValue.retention;
      obj['retention'] = {"days": numOfDays};
    }
    return obj;
  }

  addResourcePoolPolicy(obj) {
    if( this.selectedEntity && this.selectedEntity.entity_id !== '' &&
       this.selectedEntity.vcenter_instanceId !== '' ) {
        this.subscribeHandler = this.service.addResourcePoolPolicy(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId, obj)
          .subscribe(
            res => {
              this.handleSuccess();
            },
            error => this.handleError(error),
            () => this.logOperationCompleted('policy added to the resource pool')
          );
    }
    else {
    }
  }

  updateResourcePoolPolicy(obj) {
    if( this.selectedEntity && this.selectedEntity.entity_id !== '' &&
       this.selectedEntity.vcenter_instanceId !== '' ) {
        this.subscribeHandler = this.service.updateResourcePoolPolicy(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId, obj)
          .subscribe(
            res => {
              this.handleSuccess();
            },
            error => this.handleError(error),
            () => this.logOperationCompleted('policy updated of the resource pool')
          );
    }
    else {
    }
  }

  addVmPolicy(obj) {
    if( this.selectedEntity && this.selectedEntity.entity_id !== '' &&
       this.selectedEntity.vcenter_instanceId !== '' ) {
      this.subscribeHandler = this.service.addVmPolicy(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId, obj)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => this.logOperationCompleted('policy added of the virtual machine')
        );
    }
    else {
    }
  }

  updateVmPolicy(obj) {
    if( this.selectedEntity && this.selectedEntity.entity_id !== '' &&
       this.selectedEntity.vcenter_instanceId !== '' ) {
      this.subscribeHandler = this.service.updateVmPolicy(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId, obj)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => this.logOperationCompleted('policy updated of the virtual machine')
        );
    }
    else {
    }
  }

  handleSuccess() {
    this.isRequestPending = false;
    this.emitData.status = 'success';
    this.emitter.emit(this.emitData);
  }


  handleError(error) {
    this.isRequestPending = false;
    this.emitData.status = 'error';
    this.emitter.emit(this.emitData);
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/apply-policy/apply-policy.component.ts